export const test = {
  state: {
    tests: []
  },
  mutations: {
    addTest (state, payload) {
      state.tests = state.tests.concat(payload)
    },
    setTests (state, payload) {
      state.tests = payload
    }
  },
  actions: {
    addTest ({ commit }, payload) {
      return commit('addTest', payload)
    },
    setTests ({ commit }, payload) {
      return commit('setTests', payload)
    }
  },
  getters: {
    getTests (state) {
      return state.tests
    }
  }
}
